module.exports = __webpack_public_path__ + "static/img/SearchDetailHouse2.9431342.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailHouse2.png
// module id = 735
// module chunks = 0